import { gql } from "gql";

export const GET_ENTITIES_NAME = gql(/* GraphQL */ `
  query GetEntitiesName($namesQuery: NamedTypesQuery!) {
    getNamedTypeNames(namesQuery: $namesQuery) {
      name
    }
  }
`);
